import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GruposRentabilidadeApi } from '../apis/grupos-rentabilidade.api';
import { IGruposRentabilidadeResponse } from '../interfaces/grupos-rentabilidade-response.interface';

export interface IEscalaRentabilidade {
  id: number;
  escalaId: number;
  nome: string;
  simbolo: string;
  descricao: string;
}

@Injectable({
  providedIn: 'root'
})
export class EscalasRentabilidadeStore {
  private grupos$ = new BehaviorSubject<IGruposRentabilidadeResponse[]>([]);
  private loaded = false;
  private carregando = false;

  constructor(private gruposApi: GruposRentabilidadeApi) {}

  getGrupos$(): Observable<IGruposRentabilidadeResponse[]> {
    if (!this.loaded) {
      this.fetch();
    }
    return this.grupos$.asObservable();
  }

  getEscalas$(): Observable<IEscalaRentabilidade[]> {
    return this.getGrupos$().pipe(
      map(grupos => grupos.map(g => ({
        id: g.id,
        escalaId: g.escala,
        nome: g.nome,
        simbolo: g.escalaSimbolo,
        descricao: g.descricao ?? ''
      })))
    );
  }

  getEscalaById$(escalaId: number): Observable<IEscalaRentabilidade> {
    return this.getEscalas$().pipe(
      map(escalas => escalas.find(e => e.escalaId === escalaId))
    );
  }

  fetch(): void {
    if (this.carregando) {
      return;
    }
    this.carregando = true;
    this.gruposApi.fetchList().subscribe({
      next: (grupos) => {
        this.grupos$.next(grupos ?? []);
        this.loaded = true;
        this.carregando = false;
      },
      error: (error) => {
        console.error('Erro ao carregar grupos de rentabilidade:', error);
        this.loaded = true;
        this.carregando = false;
      }
    });
  }

  refresh(): void {
    this.loaded = false;
    this.fetch();
  }
}
